export default "__VITE_ASSET__Cf0IcbKQ__"